// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section[data-v-5f2855f2]{padding:10px 10px}`, "",{"version":3,"sources":["webpack://./apps/settings/src/components/PersonalInfo/LocaleSection/LocaleSection.vue"],"names":[],"mappings":"AACA,yBACC,iBAAA","sourcesContent":["\nsection {\n\tpadding: 10px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
